var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 33 24.159",
    enableBackground: "new 0 0 33 24.159",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#00386C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M30.359,10.522 v9.735c0,1.878-1.524,3.402-3.402,3.402H3.902c-1.878,0-3.402-1.524-3.402-3.402V5.958c0-1.878,1.524-3.4,3.402-3.4h18.642"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#00386C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M1.104,4.024 l12.15,11.8c1.233,1.124,3.118,1.124,4.351,0l5.686-5.407"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00386C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 10.227,
    y1: 12.884,
    x2: 1.104,
    y2: 22.324
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00386C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 20.577,
    y1: 13,
    x2: 29.856,
    y2: 22.038
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#00386C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 26.889,
    cy: 6.111,
    r: 5.611
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#00386C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 26.245,4.024 28.099,6.111 26.245,8.016  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00386C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 23.78,
    y1: 6.111,
    x2: 28.099,
    y2: 6.111
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00386C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 29.856,
    y1: 4.024,
    x2: 29.856,
    y2: 8.249
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.b11605658ba3baa232cd00cf03edf7a8.svg";
export { ForwardRef as ReactComponent };